import { render, staticRenderFns } from "./EnviadasEPendentesModal.vue?vue&type=template&id=493add53&scoped=true"
import script from "./EnviadasEPendentesModal.vue?vue&type=script&lang=js"
export * from "./EnviadasEPendentesModal.vue?vue&type=script&lang=js"
import style0 from "./EnviadasEPendentesModal.vue?vue&type=style&index=0&id=493add53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493add53",
  null
  
)

export default component.exports